// extracted by css-extract-rspack-plugin
export default {"imageContainer":"ImagePreviewDialog-module__imageContainer__U6zez","image":"ImagePreviewDialog-module__image__tSx4S"};